import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import { modelsApi } from "../../../../../API/axiosInstance";
import { toast } from "react-toastify";

const DeleteTopicDialog = ({ open, onClose, sessionData, token, onSave }) => {
  const [confirmText, setConfirmText] = useState("");
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      const response = await modelsApi.delete(
        `/topics/${sessionData._id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (onSave) onSave(response.data);
      onClose();
      toast.success("Topic deleted successfully");
    } catch (error) {
      if (error.response) {
        toast.error(
          error.response.data.message ||
            error.response.data.detail ||
            "Server error"
        );
      } else if (error.request) {
        toast.error("Network error. Please check connection and try again.");
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ fontWeight: 700 }}>
        Confirm Topic Deletion
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 2, fontSize: "0.9rem", color: "#374151" }}>
          Are you sure you want to delete this topic? This action cannot be
          undone. Please type the topic name below to confirm deletion:
        </Typography>
        <Typography
          sx={{
            mb: 2,
            fontWeight: 600,
            fontFamily: "Host Grotesk, sans-serif",
            color: "#ef4444",
          }}
        >
          {sessionData?.topic}
        </Typography>

        <TextField
          fullWidth
          variant="outlined"
          label="Type topic name to confirm"
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
          disabled={loading}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          variant="outlined"
          onClick={onClose}
          disabled={loading}
          sx={{
            borderColor: "#9ca3af",
            color: "#9ca3af",
            fontWeight: 600,
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleDelete}
          disabled={confirmText !== sessionData?.topic || loading}
          sx={{
            fontWeight: 700,
            borderRadius: "10px",
            textTransform: "none",
          }}
        >
          {loading ? "Deleting..." : "Confirm Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteTopicDialog;
